import type { MyCheckInPassResponse } from "@lbcrm-api/check-in-passes/check-in-passes.responses";
import { useAuth } from "src/authentication/hooks/useAuth";
import useSWR from "swr";

/** The passes somebody can use now, for themselves or the people they're responsible for */
export const useMyCheckInPasses = () => {
    const { person } = useAuth();

    // Somebody signed out, or with no profile yet, would only be refused
    const { data, error } = useSWR<MyCheckInPassResponse[]>(person ? "profile/check-in-passes" : null);

    return { passes: data, error };
};
